import { CalendarDate, type DateValue } from '@internationalized/date'
import dayjs from 'dayjs'
import localeSl from 'dayjs/locale/sl'
import advancedFormat from 'dayjs/plugin/advancedFormat'
dayjs.extend(advancedFormat)
dayjs.locale(localeSl)

const formatDate = (dateToFormat: Date | number | string, showTime = false) => {
    const formatType = showTime ? 'DD.MM.YYYY, HH:mm' : 'DD.MM.YYYY'
    const date = dayjs(dateToFormat).format('DD.MM.YYYY')
    if (!date || date === '30.12.1899' || date === '01.01.0001') {
        return '/'
    }
    return dayjs(dateToFormat).format(formatType)
}

/**
 * Nuxt UI's date components model their value as an @internationalized/date
 * object, while our API payloads and query strings stay ISO strings. These two
 * helpers are the conversion boundary — see vue-spec libraries.md.
 */
const toCalendarDate = (value?: Date | string | null): CalendarDate | undefined => {
    if (!value) return undefined
    const parsed = dayjs(value)
    if (!parsed.isValid()) return undefined
    return new CalendarDate(parsed.year(), parsed.month() + 1, parsed.date())
}

const fromCalendarDate = (value?: DateValue | null): string => {
    if (!value) return ''
    return `${value.year}-${String(value.month).padStart(2, '0')}-${String(value.day).padStart(2, '0')}`
}

export default dayjs
export { formatDate, fromCalendarDate, toCalendarDate }
